module.exports = __webpack_public_path__ + "img/Zhang.4d7120ac.jpeg";